"use strict";

const EVENTS = {
    froalaInternalKeydown: "ldc-froala-internal-key-down",
    editInPartnerView: "ldc-edit-in-partner-view",
    showInPartnerView: "ldc-show-in-partner-view",
    insertEditor: "ldc-insert-editor",
    deleteEditor: "ldc-delete-editor",

    // this event is triggered, once user clicks on card saved and server confirmed card has been saved
    onCardSavedInPartnerView: "ldc-on-card-saved-in-partner-view",

    onContentAnchorAdded: "ldc-content-anchor-added",

    // this should be triggered once a newly created card has been saved for the first time only!
    newCardSaved: "ldc-new-card-saved",

    froalaToolbarShow: "ldc-froala-toolbar-show",
    selectizeItemAdded: "ldc-froala-selectize-item-added",
    editorContentChanged: "ldc-editor-content-changed",
};

module.exports.events = EVENTS;

module.exports.dispatch = function (name, dispatchOn, detail = {}, opts = {}) {
    const { bubbles: bubbles = true, composed: composed = true } = opts;

    const e = new CustomEvent(name, {
        bubbles: bubbles,
        composed: composed,
        detail: detail,
    });

    dispatchOn.dispatchEvent(e);
};

module.exports.displayCard = function (dispatchOn, instanceId, opts) {
    __cardSearchEvent("show", dispatchOn, instanceId, opts);
};

module.exports.cardSearchEvent = function (name, dispatchOn, instanceId, opts) {
    __cardSearchEvent(name, dispatchOn, instanceId, opts);
};

function __cardSearchEvent(name, dispatchOn, instanceId, opts = {}) {
    const {
        composed: composed = false,
        openInPartner: openInPartner = false,
        inNewWindow: inNewWindow = false,
        cardTitle: title = null,
        scrollToElementSelector: scrollToElementSelector = null,
    } = opts;

    const eventName = "card-search-" + name;
    const e = new CustomEvent(eventName, {
        bubbles: true,
        composed: composed,
        detail: {
            instanceId: instanceId,
            openInPartner: openInPartner,
            inNewWindow: inNewWindow,
            cardTitle: title,
            anchorId: opts.anchorId, // this can be undefined
            hasView: opts.hasView,
            scrollToElementSelector: scrollToElementSelector,
        },
    });
    dispatchOn.dispatchEvent(e);
    console.log("Dispatch event: ", eventName, dispatchOn);
}

module.exports.insertEditor = function (
    instance,
    at,
    newEditorName,
    mementoBefore,
    mementoAfter,
    newEditorStateProvider = null,
) {
    const detail = {
        insertAt: at,
        instance: instance,
        newEditor: newEditorName,
        newEditorStateProvider: newEditorStateProvider,
        mementoBefore: mementoBefore,
        mementoAfter: mementoAfter,
    };

    module.exports.dispatch(EVENTS.insertEditor, instance, detail);
};
